<!-- Modal backdrop -->
<div class="modal-backdrop fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4"
     (click)="onBackdropClick($event)">

  <!-- Modal panel -->
  <div class="relative w-full max-w-2xl max-h-[70vh] bg-white dark:bg-secondary-800 rounded-xl shadow-2xl border border-gray-200 dark:border-gray-700 flex flex-col">

    <!-- Close button -->
    <button (click)="close()"
            class="absolute top-4 right-4 z-10 p-1.5 rounded-lg text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-secondary-700 transition-colors">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5">
        <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
      </svg>
    </button>

    <!-- Loading state -->
    <div *ngIf="loading" class="flex justify-center items-center py-20">
      <svg class="animate-spin h-6 w-6 text-blue-royal" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
    </div>

    <!-- Content -->
    <div *ngIf="!loading && lead" class="p-6 overflow-y-auto">

      <!-- Header: Person info -->
      <div class="flex items-start gap-4 pr-8">
        <ng-container *ngIf="photoUrl && !photoError; else initialsAvatar">
          <img [src]="photoUrl" [alt]="lead.person_name"
               class="w-16 h-16 rounded-full object-cover flex-shrink-0"
               (error)="photoError = true">
        </ng-container>
        <ng-template #initialsAvatar>
          <div class="w-16 h-16 rounded-full bg-primary flex items-center justify-center text-white text-lg font-semibold flex-shrink-0">
            {{ initials }}
          </div>
        </ng-template>
        <div class="min-w-0 flex-1">
          <div class="flex items-center gap-2">
            <h2 class="text-xl font-semibold text-gray-900 dark:text-white">{{ lead.person_name }}</h2>
            <a *ngIf="lead.person_linkedin_url" [href]="lead.person_linkedin_url" target="_blank" rel="noopener"
               class="w-6 h-6 rounded bg-primary flex items-center justify-center hover:opacity-90 transition-opacity flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="white" class="w-4 h-4">
                <path d="M4.756 2.594a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM2 5h2.5v8.5H2V5Zm4.5 0H9v1.163c.37-.645 1.278-1.338 2.633-1.338C14.05 4.825 15 6.493 15 9.15v4.35h-2.5V9.5c0-1.15-.413-2.15-1.562-2.15-1.15 0-1.688.85-1.688 2.15v4h-2.75V5Z" />
              </svg>
            </a>
          </div>
          <p class="text-sm text-gray-600 dark:text-gray-300 mt-0.5">
            <span *ngIf="departments.length > 0">{{ departments.join(', ') }} </span>{{ lead.person_title }} at {{ lead.company_name }}
          </p>
          <p *ngIf="lead.person_location" class="text-sm text-gray-500 dark:text-gray-400 mt-0.5">{{ lead.person_location }}</p>
        </div>
      </div>

      <!-- Contact info -->
      <div *ngIf="lead.person_email || lead.person_phone" class="mt-5 flex flex-wrap gap-3">
        <a *ngIf="lead.person_email" [href]="'mailto:' + lead.person_email"
           class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-secondary-700 rounded-full hover:bg-gray-200 dark:hover:bg-secondary-600 transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-3.5 h-3.5">
            <path d="M2.5 3A1.5 1.5 0 0 0 1 4.5v.793c.026.009.051.02.076.032L7.674 8.51c.206.1.446.1.652 0l6.598-3.185A.755.755 0 0 1 15 5.293V4.5A1.5 1.5 0 0 0 13.5 3h-11Z" />
            <path d="M15 6.954 8.978 9.86a2.25 2.25 0 0 1-1.956 0L1 6.954V11.5A1.5 1.5 0 0 0 2.5 13h11a1.5 1.5 0 0 0 1.5-1.5V6.954Z" />
          </svg>
          {{ lead.person_email }}
        </a>
        <span *ngIf="lead.person_phone"
              class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-secondary-700 rounded-full">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-3.5 h-3.5">
            <path fill-rule="evenodd" d="m3.855 7.286 1.067-.534a1 1 0 0 0 .542-1.046l-.44-2.858A1 1 0 0 0 4.036 2H3a1 1 0 0 0-1 1v2c0 .587.046 1.164.133 1.727a9.968 9.968 0 0 0 3.14 5.14A10.027 10.027 0 0 0 11 14h2a1 1 0 0 0 1-1v-1.036a1 1 0 0 0-.848-.988l-2.858-.44a1 1 0 0 0-1.046.542l-.534 1.067a.762.762 0 0 1-.88.395 8.03 8.03 0 0 1-4.98-4.98.762.762 0 0 1 .396-.88Z" clip-rule="evenodd" />
          </svg>
          {{ lead.person_phone }}
        </span>
      </div>

      <!-- Company info -->
      <div class="mt-6">
        <h3 class="text-sm font-semibold text-gray-900 dark:text-white mb-3">Company</h3>
        <div class="bg-gray-50 dark:bg-secondary-700 rounded-lg p-4">
          <div class="grid grid-cols-2 gap-3">
            <div>
              <span class="text-xs text-gray-500 dark:text-gray-400">Name</span>
              <div class="flex items-center gap-2 mt-0.5">
                <img *ngIf="companyLogoUrl" [src]="companyLogoUrl" [alt]="lead.company_name"
                     class="w-6 h-6 rounded-lg object-contain flex-shrink-0">
                <p class="text-sm font-medium text-gray-900 dark:text-white">{{ lead.company_name }}</p>
              </div>
            </div>
            <div *ngIf="lead.company_industry">
              <span class="text-xs text-gray-500 dark:text-gray-400">Industry</span>
              <p class="text-sm font-medium text-gray-900 dark:text-white">{{ lead.company_industry }}</p>
            </div>
            <div *ngIf="lead.company_size">
              <span class="text-xs text-gray-500 dark:text-gray-400">Size</span>
              <p class="text-sm font-medium text-gray-900 dark:text-white">{{ lead.company_size }}</p>
            </div>
            <div *ngIf="lead.company_location">
              <span class="text-xs text-gray-500 dark:text-gray-400">Location</span>
              <p class="text-sm font-medium text-gray-900 dark:text-white">{{ lead.company_location }}</p>
            </div>
            <div *ngIf="companyAddress" class="col-span-2">
              <span class="text-xs text-gray-500 dark:text-gray-400">Address</span>
              <p class="text-sm font-medium text-gray-900 dark:text-white">{{ companyAddress }}</p>
            </div>
            <div *ngIf="lead.company_domain">
              <span class="text-xs text-gray-500 dark:text-gray-400">Website</span>
              <p class="text-sm font-medium text-primary">
                <a [href]="'https://' + lead.company_domain" target="_blank" rel="noopener">{{ lead.company_domain }}</a>
              </p>
            </div>
            <div *ngIf="lead.company_linkedin_url">
              <span class="text-xs text-gray-500 dark:text-gray-400">LinkedIn</span>
              <p class="text-sm font-medium">
                <a [href]="lead.company_linkedin_url" target="_blank" rel="noopener"
                   class="text-blue-700 dark:text-blue-400 hover:opacity-80 transition-opacity">
                  Company Page
                </a>
              </p>
            </div>
          </div>
          <p *ngIf="lead.company_description" class="mt-3 text-xs text-gray-500 dark:text-gray-400">{{ lead.company_description }}</p>
        </div>
      </div>

      <!-- Why this lead -->
      <div *ngIf="lead.why_this_lead" class="mt-6">
        <h3 class="text-sm font-semibold text-gray-900 dark:text-white mb-2">Why This Lead</h3>
        <p class="text-sm text-gray-600 dark:text-gray-300 bg-amber-50 dark:bg-amber-900/10 border border-amber-200 dark:border-amber-800/30 rounded-lg p-3">
          {{ lead.why_this_lead }}
        </p>
      </div>

      <!-- ICP Match Breakdown -->
      <div *ngIf="breakdownEntries.length > 0" class="mt-6">
        <h3 class="text-sm font-semibold text-gray-900 dark:text-white mb-3">ICP Match Breakdown</h3>
        <div class="space-y-2.5">
          <div *ngFor="let entry of breakdownEntries" class="flex items-center justify-between bg-gray-50 dark:bg-secondary-700 rounded-lg px-4 py-2.5">
            <div class="flex items-center gap-2.5">
              <span class="w-2 h-2 rounded-full flex-shrink-0"
                    [class]="entry.item.matched ? 'bg-green-500' : 'bg-gray-300 dark:bg-gray-600'"></span>
              <span class="text-sm text-gray-700 dark:text-gray-300">{{ entry.label }}</span>
            </div>
            <div class="flex items-center gap-3">
              <span *ngIf="entry.item.details" class="text-xs text-gray-500 dark:text-gray-400 max-w-[200px] truncate">{{ entry.item.details }}</span>
              <span class="text-sm font-medium" [class]="entry.item.matched ? 'text-green-600 dark:text-green-400' : 'text-gray-400 dark:text-gray-500'">
                {{ entry.item.score }}%
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Match Factors -->
      <div *ngIf="lead.match_factors && lead.match_factors.length > 0" class="mt-6">
        <h3 class="text-sm font-semibold text-gray-900 dark:text-white mb-3">Match Factors</h3>
        <div class="grid grid-cols-2 gap-2">
          <div *ngFor="let factor of lead.match_factors" class="bg-gray-50 dark:bg-secondary-700 rounded-lg px-4 py-3">
            <span class="text-sm text-gray-700 dark:text-gray-300">{{ factor }}</span>
          </div>
        </div>
      </div>

      <!-- Talking Points -->
      <div *ngIf="lead.talking_points && lead.talking_points.length > 0" class="mt-6">
        <h3 class="text-sm font-semibold text-gray-900 dark:text-white mb-3">Talking Points</h3>
        <ul class="space-y-2">
          <li *ngFor="let point of lead.talking_points" class="flex items-start gap-2.5 text-sm text-gray-600 dark:text-gray-300">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-4 h-4 text-primary flex-shrink-0 mt-0.5">
              <path fill-rule="evenodd" d="M8 1.75a.75.75 0 0 1 .692.462l1.41 3.393 3.664.293a.75.75 0 0 1 .428 1.317l-2.791 2.39.853 3.58a.75.75 0 0 1-1.12.814L8 11.86l-3.134 1.96a.75.75 0 0 1-1.12-.814l.852-3.58-2.79-2.39a.75.75 0 0 1 .427-1.317l3.664-.293 1.41-3.393A.75.75 0 0 1 8 1.75Z" clip-rule="evenodd" />
            </svg>
            {{ point }}
          </li>
        </ul>
      </div>

    </div>
  </div>
</div>
